import { render, staticRenderFns } from "./NavigationDrawerV2.vue?vue&type=template&id=e8a0ed3e&lang=pug"
import script from "./NavigationDrawerV2.vue?vue&type=script&lang=ts"
export * from "./NavigationDrawerV2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports